import { render, staticRenderFns } from "./CreatePosterPopup.vue?vue&type=template&id=bd83d596&scoped=true"
import script from "./CreatePosterPopup.vue?vue&type=script&lang=js"
export * from "./CreatePosterPopup.vue?vue&type=script&lang=js"
import style0 from "./CreatePosterPopup.vue?vue&type=style&index=0&id=bd83d596&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd83d596",
  null
  
)

export default component.exports